import React from 'react'
import { useTranslation } from 'react-i18next'

import Spoiler from '../../../../../../../../components/Spoiler'
import FrequencyCapSection from './FrequencyCapSection'
import LabelsSection from '../../../../reusableFields/LabelsSection'

import { TIME_UNIT_COUNT } from './FrequencyCapSection/fields'

const AdvancedSettings = ({ formik }) => {
  const { t } = useTranslation()
  const { errors, touched } = formik

  const hasFrequencyCapErrors = errors[TIME_UNIT_COUNT] && touched[TIME_UNIT_COUNT]

  return (
    <Spoiler title={t('Advanced Settings')} triggerOpen={hasFrequencyCapErrors}>
      <FrequencyCapSection formik={formik} />
      <LabelsSection
        formik={formik}
        description={t(
          'Apply a label if ads in this campaign should not be shown along side other campaigns with the same label.'
        )}
      />
    </Spoiler>
  )
}

export default AdvancedSettings
